// extracted by mini-css-extract-plugin
export default {"main":"Paginacao_main__NjLLk","registros":"Paginacao_registros__YDP5X","btnPage":"Paginacao_btnPage__kCDY3"};